import TeacherLevel from './src/main';

/* istanbul ignore next */
TeacherLevel.install = function(Vue) {
  Vue.component(TeacherLevel.name, TeacherLevel);
};

export default TeacherLevel;
